"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _namespaceComponent = require("@ux/namespace-component");

var _component = require("@ux/component");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Expander =
/*#__PURE__*/
function (_NamespaceConsumer) {
  _inherits(Expander, _NamespaceConsumer);

  function Expander(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Expander);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Expander)).call.apply(_getPrototypeOf2, [this, props].concat(args)));
    _this.state = {
      maxHeight: 0,
      hasOverflow: false
    };
    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
    _this.element = _react["default"].createRef();
    return _this;
  }

  _createClass(Expander, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setDimensions();

      _component.eventdist.on('resize', this.setDimensions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // after children render, recalculate dimensions
      this.setDimensions();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _component.eventdist.off('resize', this.setDimensions);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions() {
      var offsetTop = this.element.current.offsetTop + 42; // 42 = meaning of life

      var maxHeight = window.innerHeight - offsetTop - 150;
      var height = this.element.current.clientHeight;
      var hasOverflow = height > maxHeight;

      if (this.state.hasOverflow !== hasOverflow && maxHeight !== height) {
        this.setState({
          hasOverflow: hasOverflow
        });
        this.props.onOverflow && this.props.onOverflow(hasOverflow);
      }

      if (this.state.maxHeight !== maxHeight) {
        this.setState({
          maxHeight: maxHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          hasOverflow = _this$state.hasOverflow,
          maxHeight = _this$state.maxHeight;

      var expanderElement = _react["default"].createElement("div", {
        ref: this.element
      }, this.props.children);

      if (hasOverflow) {
        expanderElement = _react["default"].createElement("div", {
          ref: this.element,
          className: this.namespace('hc-expander'),
          style: {
            maxHeight: maxHeight
          }
        }, this.props.children);
      }

      return expanderElement;
    }
  }]);

  return Expander;
}(_namespaceComponent.NamespaceConsumer);

Expander.propTypes = {
  children: _propTypes["default"].node,
  onOverflow: _propTypes["default"].func
};
var _default = Expander;
exports["default"] = _default;